// profile.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { AuthStoreService, NavigationService } from '@app/shared/services';
import { ProfileSetupService, requiresProfileSetup } from '../services/user/profile-setup.service';

/**
 * /member/my の is_complete が 0 の場合は「設定未完了」とみなし、
 * 追加設定のため SetupProfile をモーダルで表示する。
 * （/tabs/home 以外のルートに canActivate で付与し、home のみガードなしで許可する）
 */
export const profileGuard: CanActivateFn = async (
  _,
  state: RouterStateSnapshot
) => {
  const authStoreService = inject(AuthStoreService);
  const navigationService = inject(NavigationService);
  const profileSetup = inject(ProfileSetupService);

  const currentUser = await authStoreService.waitForCurrentUser();
  if (requiresProfileSetup(currentUser)) {
    if (await profileSetup.open()) {
      await navigationService.navigateToRoot(state.url);
    } else {
      await navigationService.navigateToRoot('/tabs/home');
    }
    return false;
  }
  return true;
};
